<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-3 sidebar-org bg-custom-blue py-3">

        <!-- Header left sidebar -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="mb-0">{{ $t("views.nav.manageObjectives") }}</h4>
          <button v-if="objectivesContentView === 'detail'" @click="toggleObjectivesContentView('add')" class="btn btn-sm btn-primary">+ {{ $t("general.add") }}</button>
          <button v-if="objectivesContentView === 'add' && objectivesSidebarView === 'show'" @click="toggleObjectivesSidebarView('hide')" class="btn btn-sm btn-outline-primary">
            &lt; {{ $t("general.hide") }}
          </button>
        </div>

        <!-- Time-Filter -->
        <div class="row mt-4">
          <div class="col-6">
            <div class="dropdown">
              <button class="btn btn-sm dropdown-toggle bg-white text-start" style="width: 200px" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <span>{{ formatDate(new Date(filterValidFrom)) }} &nbsp;-&nbsp; {{ formatDate(new Date(filterValidTo)) }}</span>
              </button>
              <div class="dropdown-menu border-secondary p-3">
                <div class="row">
                  <div class="col-12">
                    <button @click="filterObjectives(new Date().toISOString().slice(0, 10), new Date().toISOString().slice(0, 10))" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ $t("general.today") }}</button>
                    <button @click="filterObjectives((new Date().getFullYear() + 1).toString() + '-01-01', (new Date().getFullYear() + 1).toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ new Date().getFullYear() + 1 }}</button>
                    <button @click="filterObjectives(new Date().getFullYear().toString() + '-01-01', new Date().getFullYear().toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ new Date().getFullYear() }}</button>
                    <button @click="filterObjectives((new Date().getFullYear() - 1).toString() + '-01-01', (new Date().getFullYear() - 1).toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ new Date().getFullYear() - 1 }}</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button @click="filterObjectives(new Date().getFullYear().toString() + '-01-01', new Date().getFullYear().toString() + '-03-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">Q1</button>
                    <button @click="filterObjectives(new Date().getFullYear().toString() + '-04-01', new Date().getFullYear().toString() + '-06-30')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">Q2</button>
                    <button @click="filterObjectives(new Date().getFullYear().toString() + '-07-01', new Date().getFullYear().toString() + '-09-30')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">Q3</button>
                    <button @click="filterObjectives(new Date().getFullYear().toString() + '-10-01', new Date().getFullYear().toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">Q4</button>
                  </div>
                </div>
                <hr class="dropdown-divider">
                <div class="row">
                  <div class="col-6">
                    <label for="filterValidFrom" class="form-label">{{ $t("views.kpi.periods.from") }}:</label>
                    <input v-model="filterValidFrom" type="date" class="form-control form-control-sm" id="filterValidFrom">
                  </div>
                  <div class="col-6">
                    <label for="filterValidTo" class="form-label">{{ $t("views.kpi.periods.to") }}:</label>
                    <input v-model="filterValidTo" type="date" class="form-control form-control-sm" id="filterValidTo">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <button @click="filterObjectives(filterValidFrom, filterValidTo)" class="btn btn-sm btn-outline-primary mt-3" type="button">{{ $t("views.kpi.periods.filter") }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 text-end">
            <span class="me-2 fs-08 text-muted" >{{ $t("views.objective.detail.objectiveView") }}:</span>
            <div class="btn-group btn-group-objectives-view" role="group">
              <button @click="toggleObjectivesTreeView('org')" type="button" class="btn btn-sm btn-outline-primary" :class="objectivesTreeView === 'org' ? 'active' : ''">{{ $t("views.objective.detail.org") }}</button>
              <button @click="toggleObjectivesTreeView('objective')" type="button" class="btn btn-sm btn-outline-primary" :class="objectivesTreeView === 'objective' ? 'active' : ''">{{ $t("views.objective.detail.objective") }}</button>
            </div>
          </div>
        </div>

        <!-- Search & Slider -->
        <div class="row mt-1">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center">
              <!-- Suchfeld links -->
              <div class="me-3" style="width: 200px"> <input v-model="searchText" type="text" :placeholder="$t('general.placeholderSearch')" class="form-control form-control-sm mt-1" />
              </div>
              <!-- Level-Slider von 2 bis maxTreeLevel rechts -->
              <div class="d-flex flex-column align-items-start mb-2">
                <div class="fs-08 text-muted mb-1"> {{ $t('general.treeViewLevels') }}: {{ autoOpenDepth }} </div>
                <div class="d-flex align-items-center gap-2">
                  <input type="range" class="form-range foc-range" min="2" :max="maxTreeDepth" step="1" v-model="autoOpenDepth" :key="sliderKey">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <ObjectiveTree v-if="'nodes' in objectives && objectives.nodes.length" :node="objectives" :depth="0" :view="objectivesTreeView"  mode="manage" :searchText="searchText" :autoOpenDepth="autoOpenDepth" class="mt-2"></ObjectiveTree>
          </div>
        </div>
      </div>
      <div class="col-9 px-5">
        <ObjectiveAdd v-if="objectivesContentView === 'add'"></ObjectiveAdd>
        <ObjectiveDetail v-else-if=" objectivesContentView === 'detail'"></ObjectiveDetail>
        <IntroObjective></IntroObjective>
      </div>
    </div>
  </div>
</template>

<script>
import ObjectiveTree from '@/components/objectives/ObjectiveTree.vue'
import ObjectiveDetail from '@/components/objectives/ObjectiveDetail.vue'
import ObjectiveAdd from '@/components/objectives/ObjectiveAdd.vue'
import IntroObjective from '@/components/guide/IntroObjective.vue'
import * as formatUtils from '@/composables/formatUtils'
import * as tree from '@/composables/tree'

export default {
  name: 'ObjectivesManageObjective',
  data () {
    return {
      objectivesTreeView: 'org',
      filterValidFrom: this.$store.state.user?.settings?.favorites?.objectiveManage?.filterValidFrom ? this.$store.state.user.settings.favorites.objectiveManage.filterValidFrom : new Date().getFullYear().toString() + '-01-01',
      filterValidTo: this.$store.state.user?.settings?.favorites?.objectiveManage?.filterValidTo ? this.$store.state.user.settings.favorites.objectiveManage.filterValidTo : (new Date().getFullYear() + 1).toString() + '-12-31',
      searchText: '',
      autoOpenDepth: 2,
      sliderKey: 0
    }
  },
  components: {
    ObjectiveTree,
    ObjectiveDetail,
    ObjectiveAdd,
    IntroObjective
  },
  computed: {
    sysParms () {
      return this.$store.state.sysParms
    },
    objectives () {
      return this.$store.state.objectives
    },
    objectivesContentView () {
      return this.$store.state.objectivesContentView
    },
    selectedObjective () {
      return this.$store.state.selectedObjective
    },

    // maximale Strukturtiefe ermitteln (Fallback 2)
    maxTreeDepth () {
      return tree.getMaxTreeDepth(this.$store.state.objectives?.nodes, 2)
    }
  },

  watch: {
    'objectives.nodes': {
      handler (nodes) {
        if (!nodes || nodes.length === 0) return

        // Set Slider Default-Level (Fallback = 2)
        const depth = this.maxTreeDepth
        const defaultLevel = this.sysParms?.objectiveTreeDefaultLevel ?? 2
        this.autoOpenDepth = Math.min(Math.max(defaultLevel, 2), depth)

        // Render Slider
        this.sliderKey++
      },
      immediate: true
    }
  },

  methods: {
    async filterObjectives (filterFrom, filterTo) {
      this.$store.commit('SET_LOADING_STATUS', true)
      this.filterValidFrom = filterFrom
      this.filterValidTo = filterTo
      await this.$store.dispatch('getObjectives', { validFrom: filterFrom, validTo: filterTo, treeView: this.objectivesTreeView })
      await this.$store.dispatch('favoriteObject', { isList: false, objectKey: 'objectiveManage', objectValue: { filterValidFrom: filterFrom, filterValidTo: filterTo } })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    toggleObjectivesContentView (objectivesContentView) {
      this.$store.dispatch('updateObjectivesContentView', objectivesContentView)
    },
    async toggleObjectivesTreeView (objectivesTreeView) {
      this.$store.commit('SET_LOADING_STATUS', true)
      this.objectivesTreeView = objectivesTreeView
      await this.$store.dispatch('getObjectives', { validFrom: this.filterValidFrom, validTo: this.filterValidTo, treeView: this.objectivesTreeView })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    formatDate (date) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.formatDate(userLocale, date)
    }
  },
  async created () {
    this.$store.commit('SET_LOADING_STATUS', true)

    // check query params for selectedObjective
    let paramSelectedObjective = ''
    if (this.$route.query.id) {
      paramSelectedObjective = this.$route.query.id
    }

    // get filter values from param object
    if (paramSelectedObjective !== '') {
      await this.$store.dispatch('getObjective', paramSelectedObjective)
      this.searchText = this.selectedObjective.name
      this.filterValidFrom = this.selectedObjective.validFrom
      this.filterValidTo = this.selectedObjective.validTo
    }

    this.$store.commit('SET_SELECTED_VIEW', 'objective')
    await this.$store.dispatch('getObjectives', { validFrom: this.filterValidFrom, validTo: this.filterValidTo, view: 'vision', treeView: this.objectivesTreeView })
    this.$store.commit('SET_LOADING_STATUS', false)

    if (Object.keys(this.selectedObjective).length) {
      await this.$store.dispatch('getObjective', this.selectedObjective.id)
    }
    await this.$store.dispatch('getOrgUnits', { validFrom: this.filterValidFrom, validTo: this.filterValidTo, view: 'org' })
    await this.$store.dispatch('getEmployees', { mode: 'default' })
    await this.$store.dispatch('getKPIs', { validFrom: this.filterValidFrom, validTo: this.filterValidTo })
    await this.$store.dispatch('getProjects', { validFrom: this.filterValidFrom, validTo: this.filterValidTo })
    await this.$store.dispatch('getStrategies', { validFrom: this.filterValidFrom, validTo: this.filterValidTo })
  }
}
</script>

<style scoped>
.dropdown-toggle::before {
  display: inline-block;
  margin-right: .255em;
  vertical-align: .2em;
  content: "";
  border-top: .3em solid;
  border-right: .3em solid transparent;
  border-bottom: 0;
  border-left: .3em solid transparent;
}
.dropdown-toggle:after {
  display: none;
}
.dropdown-menu {
  min-width: 330px;
}
</style>
